import React from "react";
import "../../css/volunteerteam.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import Modal from "../../components/Modal";
import Link from "gatsby-link";
import {
  ambassadors_team_current,
  ambassadors_team_previous,
} from "../../constant/team_constants";
import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";
let duration = 400;

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div className="item_des">{activeItem.post}</div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};
TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class ambassadors extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow } = this.state;
    const { location } = this.props;
    return (
      <ContentPage>
        <Meta
          title="Winpe | Diversity is Now | Ambassadors"
          description="View profiles of the Winpe Ambassadors- integral driving forces for Winpe initiatives, championing diversity from different external vantage points."
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="volunteer_wrapper">
            <div className="volunteer_section">
              <div className="back_page">
                <div className="back_arrow">
                  <Link to="/home/">
                    <i className="fa fa-arrow-left"> Back</i>
                  </Link>
                </div>
              </div>
              <div className="low__heading"></div>
              <div className="">
                <Heading title="Winpe Ambassadors" />
              </div>

              <ScrollAnimation
                delay={0}
                duration={2}
                animateIn="slideInRight"
                offset={600}
              >
                <div className="v_team_section">
                  <div className="row justify-content-center">
                    {ambassadors_team_current.map((item, v) => {
                      return (
                        <div className="col-md-4 col-sm-6 col-xs-12" key={v}>
                          <div className="v_card">
                            <div >
                              <div className="v_img">
                                <img
                                  src={item.imgUrl}
                                  alt={item.name}
                                  className="img-responsive"
                                  style={{width:'45%', height:'45%', borderRadius:'100%'}}
                                />
                              </div>
                              <div className="v_name">{item.name}</div>
                              <div className="v_post">{item.designation}</div>
                              <div className="v_post">{item.company}</div>
                            </div>
                            <div className="social_link">
                              <a
                                rel="noopener noreferrer"
                                href={item.link}
                                target="_blank"
                                className=""
                              >
                                <i className="fa fa-linkedin"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <br />
                  <br />
                  <br />
                 
                 
                </div>
              </ScrollAnimation>
            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

ambassadors.propTypes = {
  location: PropTypes.object,
};

export default ambassadors;



// WEBPACK FOOTER //
// ./src/pages/ambassadors/index.js